
<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      inventoty_tabs
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-search title="申請承認"></title-and-search>
      <tabs nav-style="tabs" @active="onTabChanged($event)" v-model="selectedTabModel" :value="selectedTab">
        <tab header="申請承認" ></tab>
        <tab header="一括取込"></tab>
      </tabs>
      <div>
        <div v-if="selectedTab == 1"  ><approval-history-all @bRLFlag='setbRLFlag' @selectedItemsUpd="selectedItemsUpd"/></div>
        <div v-else-if="selectedTab == 0"  ><approval-history @bRLFlag='setbRLFlag'  @selectedItemsUpd="selectedItemsUpd"/></div>
      </div>
    </div>
    <confirmation-modal tag="approvalBeforeLeaveModal" @done="approvalBeforeLeaveoConfirmedModal" />
    <confirmation-modal tag="approvalBeforeLeaveTabModal" @done="approvalBeforeLeaveoConfirmedTabModal" />
  </div>
</template>
<script>
import Vue from "vue";
import { bus } from '@/libs/bus'
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { utils } from '@/libs/utils';
import approvalHistory from '@/components/sub_pages/approval_history';
import approvalHistoryAll from '@/components/sub_pages/approval_history_all';

import { tab, tabs } from "vue-strap/dist/vue-strap.js";
export default {
  mixins: [mixinPageCommon,
    mixinDatasource],
  components: {
    "approval-history-all":approvalHistoryAll,
    "approval-history":approvalHistory,
    tab,
    tabs
  },
  data() {
    return {
      selected_tab:-1,
      selected_tab_model:-1,
      page_acl: acl.inventory,
      loading_count_box_data:false,
      bRL_Flag:false,
      local_next_leave_page:false,
      local_next_go_to_tab :-1,
      waiting_confimation:false,
      selected_items_qty :""
    };
  },
  computed: {
    selectedTabModel:{
      get(){
        return this.selected_tab_model;
      },
      set(v){
        this.selected_tab_model = v;
      }
    },
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    console.log('TEST DEBUG 210525 (73 at page_0050_approval_history_tabs.vue)[23:18]: ', { type: typeof to  ,to });
    if(this.bRL_Flag == false || (to && to.path &&  (to.path.indexOf("/approval_history") == 0 || to.path.indexOf("/approval/") > 0 ))){
      return next();
    }else{
      this.emitOnLeaveDialor("approvalBeforeLeaveModal");
      this.local_next_leave_page = next;
    }
  },
  methods: {
    selectedItemsUpd(v){
      this.selected_items_qty = v
    },
    emitOnLeaveDialor(id){
      var msg = this.selected_items_qty + " 件の申請が確認済み未承認です。<br>承認を行わないまま画面を移動しますが、よろしいですか？"
      msg += "<br><br><span style='color:red;'>※承認を行う場合は、[キャンセル]をクリックした後、<br>[承認]をクリックしてください。</span>";
      bus.$emit(id,{
        title: "",
        message: msg,
        yes_label: "ページを移動",
        no_label: "キャンセル",
        yes_color:"info",
        no_color:"default",
        model_height:"50",
        model_width:"650px"
      })
    },
    setbRLFlag(value){
      this.bRL_Flag = value;
    },
    beforeRouteLeaveFlag(){
      return this.bRL_Flag;
    },
    approvalBeforeLeaveoConfirmedModal(mode){
      if(mode == "yes"){
        this.local_next_leave_page()
      }else{
        this.local_next_leave_page(false)
        // return this.$router.push( {path:"/approval_history"});
      }
    },
    approvalBeforeLeaveoConfirmedTabModal(mode){
      if(mode == "yes"){
        var index =  this.local_next_go_to_tab
        this.changeTab(index);
       
      }
      setTimeout(() => {
        this.waiting_confimation = false;
      }, 100);
    },
    onTabChanged(index) {
      this.clearSearchFields();
      if(this.bRL_Flag == true){
        if(this.waiting_confimation == true){
          return;
        }
        this.waiting_confimation = true
        this.local_next_go_to_tab = index;
        setTimeout(() => {
          this.selectedTabModel = (index==0)?1:0;
        }, 10);
        this.emitOnLeaveDialor("approvalBeforeLeaveTabModal");
      }else{
        this.changeTab(index);
      }
    },
    changeTab(index){
          if(this.selectedTab != index){
        this.selectedTab = index;
        this.selectedTabModel = index;
        switch (index) {
          case 0:
            return this.$router.push( {path:"/approval_history"});
            break;
          case 1:
            return this.$router.push( {path:"/approval_history/all"});
            break;
          default:
            break;
        }
      }
    }
  },
  mounted() {

    this.selectedTab = this.$route.meta.tab_index;
    this.selectedTabModel = this.$route.meta.tab_index;

  },
  beforeDestroy() {
    console.log('TEST DEBUG 210606 (164 at page_0050_approval_history_tabs.vue)[02:16]: beforeDestroy', {  });
  },
  beforeMount() {},
};
</script>
<style>
/* 
  To change the .nav-tabs colors, do it at the App.vue page, then it will be global.
*/
</style>



// WEBPACK FOOTER //
// page_0050_approval_history_tabs.vue?d1527632